import {css} from 'lit';
export const styles = css`:host {
  --container-height: 150px; /* Component automatically set width depending on the aspect ratio. */
  --label-border: 1px solid var(--border-light-secondary);
  --label-border-radius: 0;
  --label-bg: transparent;
  --label-bg-hover: var(--primary-100);
  --label-bg-active: var(--primary-200);
  --label-padding: 8px;
  --label-icon-margin-bottom: 8px;
  --label-icon-font-size: 40px;
  --label-icon-font-color: var(--dark-secondary);
  --label-info-primary-margin-bottom: 4px;
  --label-info-primary-font-size: 12px;
  --label-info-primary-font-color: inherit;
  --label-info-primary-font-weight: 700;
  --label-info-secondary-font-size: 11px;
  --label-info-secondary-font-color: var(--dark-secondary);
  --label-info-secondary-font-weight: 400;
  --actions-margin-top: 16px;

  display: block;
}

.upload-container {
  position: relative;
  height: var(--container-height);
  margin-left: auto;
  margin-right: auto;
  background-color: var(--container-bg);
  transition: background-image var(--transition-timing)
    var(--transition-duration);
}

@media (hover: hover) {
    .upload-container:hover {
      background-color: var(--container-bg-hover);
    }
  }

.upload-container:active {
    background-color: var(--container-bg-active);
  }

.input-label {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: var(--label-padding);
  border: var(--label-border);
  border-radius: var(--label-border-radius);
  background-size: cover;
  background-position: center center;
  text-align: center;
  transition: all var(--transition-timing) var(--transition-duration);
}

.input-label ef-icon {
    margin-bottom: var(--label-icon-margin-bottom);
    color: var(--label-icon-font-color);
    font-size: var(--label-icon-font-size);
  }

.input-label .info-primary {
    margin-bottom: var(--label-info-primary-margin-bottom);
    color: var(--label-info-primary-font-color);
    font-size: var(--label-info-primary-font-size);
    font-weight: var(--label-info-primary-font-weight);
  }

.input-label .info-secondary {
    color: var(--label-info-secondary-font-color);
    font-size: var(--label-info-secondary-font-size);
    font-weight: var(--label-info-secondary-font-weight);
  }

.input-label .info-secondary span {
      white-space: nowrap;
    }

input[type='file'] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 1;
}

input[type='file'].focus-visible + .input-label {
      outline: 1px solid var(--link-focus-outline);
      outline-offset: 2px;
    }

input[type='file'].focus-visible + .input-label {
      outline: 1px solid var(--link-focus-outline);
      outline-offset: 2px;
    }

input[type='file']:focus-visible + .input-label {
      outline: 1px solid var(--link-focus-outline);
      outline-offset: 2px;
    }

@media (hover: hover) {
      input[type='file'].active + .input-label, input[type='file']:hover + .input-label {
        filter: grayscale(100%);
        background-color: var(--label-bg-hover);
      }
  }

input[type='file']:active + .input-label {
      background-color: var(--label-bg-active);
    }

.actions-group {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: var(--actions-margin-top);
}
`;
export default styles;
